import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 91" fill="currentColor" {...this.props}><path d="M3.2 0L0 3.3v11.3l7 6.7 7-6.7V0zM4.8 39.4L3 41.3v6.4l4 3.8 4-3.8v-8.3H4.8zM3.2 69.1L0 72.4v11.3l7 6.7 7-6.7V69.1zM6 25.4h2v10H6zM6 55.4h2v10H6z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/panel-route.inline.svg